import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// Format price
export function formatPrice(price) {
    if (!price) return 'Free';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(price);
}

// Format date
export function formatDate(dateString) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

// Truncate text
export function truncateText(text, maxLength = 150) {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
}

// Get initials from name
export function getInitials(name) {
    if (!name) return '?';
    return name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}

// Extract instructor from title
export function extractInstructor(title) {
    if (!title) return null;
    const match = title.match(/with\s+([A-Z][a-zA-Z.\s]+?)(?:\s*[-–]|\s*$)/);
    return match ? match[1].trim() : null;
}

// Parse video ID structure
export function parseVideoId(videoId) {
    const idStr = String(videoId);
    if (idStr.length === 7) {
        return {
            typeDigit: parseInt(idStr[0]),
            courseId: parseInt(idStr.slice(1, 5)),
            lessonNumber: parseInt(idStr.slice(5, 7)),
        };
    } else if (idStr.length === 5) {
        return {
            typeDigit: parseInt(idStr[0]),
            courseId: ['4', '5', '6'].includes(idStr[0]) ? parseInt(idStr.slice(1, 5)) : null,
            lessonNumber: null,
        };
    }
    return { typeDigit: null, courseId: null, lessonNumber: null };
}
